(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState ? initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        }) : Array.from({
            length: 4
        }, function() {
            return Array(4).fill(0);
        });
        this.state = this.initialState.map(function(row) {
            return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
        });
        this.size = 4;
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getEmptyCells",
            value: function getEmptyCells() {
                var emptyCells = [];
                for(var row = 0; row < this.size; row++){
                    for(var col = 0; col < this.size; col++)if (this.state[row][col] === 0) emptyCells.push({
                        row: row,
                        col: col
                    });
                }
                return emptyCells;
            }
        },
        {
            key: "addRandomCell",
            value: function addRandomCell() {
                var emptyCells = this.getEmptyCells();
                if (emptyCells.length === 0) return;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomIndex = emptyCells[randomIndex], row = _emptyCells_randomIndex.row, col = _emptyCells_randomIndex.col;
                var value = Math.random() < 0.9 ? 2 : 4;
                this.state[row][col] = value;
            }
        },
        {
            /**
   * Зсуває та зливає рядок вліво
   * @returns {object} {newRow, gainedScore, moved}
   */ key: "slideAndMerge",
            value: function slideAndMerge(row) {
                // Фільтруємо всі ненульові значення
                var nonZero = row.filter(function(value) {
                    return value !== 0;
                });
                var result = [];
                var gainedScore = 0;
                var i = 0;
                // Обробляємо злиття
                while(i < nonZero.length)// Якщо поточне та наступне значення однакові - зливаємо
                if (i < nonZero.length - 1 && nonZero[i] === nonZero[i + 1]) {
                    var mergedValue = nonZero[i] * 2;
                    result.push(mergedValue);
                    gainedScore += mergedValue;
                    i += 2;
                } else {
                    result.push(nonZero[i]);
                    i++;
                }
                // Заповнюємо решту нулями
                while(result.length < this.size)result.push(0);
                // Перевіряємо чи змінився рядок
                var moved = JSON.stringify(row) !== JSON.stringify(result);
                return {
                    newRow: result,
                    gainedScore: gainedScore,
                    moved: moved
                };
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== "playing") return false;
                var movedAny = false;
                var totalGained = 0;
                var newState = [];
                for(var row = 0; row < this.size; row++){
                    var _this_slideAndMerge = this.slideAndMerge(this.state[row]), newRow = _this_slideAndMerge.newRow, gainedScore = _this_slideAndMerge.gainedScore, moved = _this_slideAndMerge.moved;
                    newState.push(newRow);
                    if (moved) movedAny = true;
                    totalGained += gainedScore;
                }
                // Якщо хоча б щось змінилось
                if (movedAny) {
                    this.state = newState;
                    this.score += totalGained;
                    this.addRandomCell();
                    this.updateStatus();
                }
                return movedAny;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.status !== "playing") return false;
                var movedAny = false;
                var totalGained = 0;
                var newState = [];
                // Обробляємо кожен рядок (реверс -> slideAndMerge -> реверс назад)
                for(var row = 0; row < this.size; row++){
                    var reversedRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.state[row]).reverse();
                    var _this_slideAndMerge = this.slideAndMerge(reversedRow), newRow = _this_slideAndMerge.newRow, gainedScore = _this_slideAndMerge.gainedScore, moved = _this_slideAndMerge.moved;
                    var finalRow = newRow.reverse();
                    newState.push(finalRow);
                    if (moved) movedAny = true;
                    totalGained += gainedScore;
                }
                if (movedAny) {
                    this.state = newState;
                    this.score += totalGained;
                    this.addRandomCell();
                    this.updateStatus();
                }
                return movedAny;
            }
        },
        {
            /**
   * Рух вгору
   */ key: "moveUp",
            value: function moveUp() {
                if (this.status !== "playing") return false;
                var movedAny = false;
                var totalGained = 0;
                var newState = Array.from({
                    length: 4
                }, function() {
                    return Array(4).fill(0);
                });
                for(var col = 0; col < this.size; col++){
                    var column = [];
                    for(var row = 0; row < this.size; row++)column.push(this.state[row][col]);
                    var _this_slideAndMerge = this.slideAndMerge(column), newRow = _this_slideAndMerge.newRow, gainedScore = _this_slideAndMerge.gainedScore, moved = _this_slideAndMerge.moved;
                    // Записуємо колонку назад
                    for(var row1 = 0; row1 < this.size; row1++)newState[row1][col] = newRow[row1];
                    if (moved) movedAny = true;
                    totalGained += gainedScore;
                }
                if (movedAny) {
                    this.state = newState;
                    this.score += totalGained;
                    this.addRandomCell();
                    this.updateStatus();
                }
                return movedAny;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.status !== "playing") return false;
                var movedAny = false;
                var totalGained = 0;
                var newState = Array.from({
                    length: 4
                }, function() {
                    return Array(4).fill(0);
                });
                for(var col = 0; col < this.size; col++){
                    var column = [];
                    for(var row = 0; row < this.size; row++)column.push(this.state[row][col]);
                    var reversedColumn = column.reverse();
                    var _this_slideAndMerge = this.slideAndMerge(reversedColumn), newRow = _this_slideAndMerge.newRow, gainedScore = _this_slideAndMerge.gainedScore, moved = _this_slideAndMerge.moved;
                    var finalColumn = newRow.reverse();
                    // Записуємо колонку назад
                    for(var row1 = 0; row1 < this.size; row1++)newState[row1][col] = finalColumn[row1];
                    if (moved) movedAny = true;
                    totalGained += gainedScore;
                }
                if (movedAny) {
                    this.state = newState;
                    this.score += totalGained;
                    this.addRandomCell();
                    this.updateStatus();
                }
                return movedAny;
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                // Повертаємо копію, щоб зовнішній код не міг змінити стан
                return this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status === "playing") return;
                this.status = "playing";
                this.addRandomCell();
                this.addRandomCell();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = this.initialState.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var row = 0; row < this.size; row++)for(var col = 0; col < this.size; col++){
                    if (this.state[row][col] === 2048) return true;
                }
                return false;
            }
        },
        {
            key: "hasMoves",
            value: function hasMoves() {
                if (this.getEmptyCells().length > 0) return true;
                // Перевіряємо горизонтальні сусідні клітинки
                for(var row = 0; row < this.size; row++)for(var col = 0; col < this.size - 1; col++){
                    if (this.state[row][col] === this.state[row][col + 1]) return true;
                }
                // Перевіряємо вертикальні сусідні клітинки
                for(var col1 = 0; col1 < this.size; col1++)for(var row1 = 0; row1 < this.size - 1; row1++){
                    if (this.state[row1][col1] === this.state[row1 + 1][col1]) return true;
                }
                return false;
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                if (this.checkWin() && this.status !== "win") {
                    this.status = "win";
                    return;
                }
                if (!this.hasMoves()) {
                    this.status = "lose";
                    return;
                }
                this.status = "playing";
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$startBtn = document.querySelector(".button");
var $197cd56b15c33885$var$startMsg = document.querySelector(".message-start");
var $197cd56b15c33885$var$winMsg = document.querySelector(".message-win");
var $197cd56b15c33885$var$loseMsg = document.querySelector(".message-lose");
function $197cd56b15c33885$var$drawGame() {
    var field = $197cd56b15c33885$var$game.getState();
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    for(var i = 0; i < $197cd56b15c33885$var$cells.length; i++){
        var row = Math.floor(i / 4);
        var col = i % 4;
        var value = field[row][col];
        $197cd56b15c33885$var$cells[i].textContent = value === 0 ? "" : value;
        $197cd56b15c33885$var$cells[i].className = "field-cell";
        if (value !== 0) $197cd56b15c33885$var$cells[i].classList.add("field-cell--".concat(value));
    }
    $197cd56b15c33885$var$scoreEl.textContent = $197cd56b15c33885$var$game.getScore();
    if (gameStatus === "win") $197cd56b15c33885$var$winMsg.classList.remove("hidden");
    else $197cd56b15c33885$var$winMsg.classList.add("hidden");
    if (gameStatus === "lose") $197cd56b15c33885$var$loseMsg.classList.remove("hidden");
    else $197cd56b15c33885$var$loseMsg.classList.add("hidden");
}
$197cd56b15c33885$var$startBtn.addEventListener("click", function() {
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    if (gameStatus === "idle") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    if ($197cd56b15c33885$var$startBtn.textContent !== "Restart") {
        $197cd56b15c33885$var$startBtn.textContent = "Restart";
        $197cd56b15c33885$var$startBtn.classList.remove("start");
        $197cd56b15c33885$var$startBtn.classList.add("restart");
    }
    // Hide all messages
    $197cd56b15c33885$var$startMsg.classList.add("hidden");
    $197cd56b15c33885$var$winMsg.classList.add("hidden");
    $197cd56b15c33885$var$loseMsg.classList.add("hidden");
    $197cd56b15c33885$var$drawGame();
});
document.addEventListener("keydown", function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var moved = false;
    switch(e.key){
        case "ArrowLeft":
            e.preventDefault();
            moved = $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            e.preventDefault();
            moved = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            e.preventDefault();
            moved = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            e.preventDefault();
            moved = $197cd56b15c33885$var$game.moveDown();
            break;
    }
    if (moved) $197cd56b15c33885$var$drawGame();
});

})();
//# sourceMappingURL=index.5fcb3e5c.js.map
